@if(children() && children()?.length){
<main class="flex flex-col w-screen h-full bg-white">
    <!-- 탭 컨테이너에 마스크와 오버플로우 처리 추가 -->
    <div class="relative container max-w-[554px] mx-auto">
        <div
            #tabContainer
            class="flex overflow-hidden overflow-x-scroll gap-3 items-center p-3 w-full scrollbar-hide cursor-grab"
            [style.mask-image]="maskStyle()"
        >
            @for (tab of myChildTabs; track $index) {
            <div
                class="flex gap-3 justify-center items-center px-3 py-2 text-sm font-semibold text-gray-400 bg-gray-50 rounded-xl border border-gray-50 transition-all duration-300 ease-in-out cursor-pointer break-keep shrink-0 hover:opacity-80"
                routerLinkActive="bg-primary-50 border-primary text-primary"
                [routerLink]="['/my-child', tab.key]"
            >
                <p class="min-w-max">{{ tab.value }}</p>
                <div class="flex justify-center items-center min-w-max">
                    <app-icon
                        [name]="tab.icon"
                        class="bg-gray-300"
                        routerLinkActive="bg-primary"
                        size="sm"
                    />
                </div>
            </div>
            }
        </div>

        <!-- 오른쪽 끝 화살표 아이콘 -->
        @if (!isScrollEnd()) {
        <div
            class="flex absolute right-1 top-1/2 justify-center items-center transform -translate-y-1/2 pointer-events-none size-6"
        >
            <img
                src="https://api.iconify.design/material-symbols:double-arrow.svg?color=%239e9e9e"
                class="animate-pulse size-6"
            />
        </div>
        }
    </div>

    <div
        class="flex flex-col bg-white rounded-t-2xl size-full min-h-dvh basis-full grow-0"
    >
        <router-outlet />
    </div>

    <app-chatbot class="fixed bottom-16 right-4 size-14 z-[999]" />
</main>
} @else {
<div class="flex justify-center items-center h-screen">
    <p class="text-lg text-gray-500">아동을 먼저 등록해주세요.</p>
</div>
}
